const routes = [
{ // 费用中心
  path: '/exportCenter',
  name: 'exportCenter',
  meta: {
    title: '任务中心',
    hasBack: true,
    volcengine: true,
  },
  component: () => import('../pages/exportCenter/index.vue'),
},
]

export default routes
